import { BrandKitAsset } from "pages/media/types";
import { FontPurpose } from "./FontsCard";
import { Card, Flex, Typography } from "antd";
import { useTranslate } from "#src/hooks";
import { useMemo } from "react";
import { FontPreviewText } from "../FontPreview";
import { GroupedFontPicker } from "pages/media/components/GroupedFontPicker/GroupedFontPicker";
import styled from "styled-components";
import { radius } from "@libertify/ui";

export const FontItemCard = ({
  item,
  currentFont,
  onFontSelectChange,
}: {
  item: FontPurpose;
  currentFont: BrandKitAsset;
  onFontSelectChange: (value: string, option: string) => void;
}) => {
  const t = useTranslate();
  const fontPreviewFontSize = useMemo(() => {
    if (item === "Title") {
      return 28;
    }
    if (item === "Subtitles") {
      return 24;
    }
    return 20;
  }, [item]);

  return (
    <Flex vertical gap={8}>
      <Card
        styles={{
          body: {
            padding: 24,
          },
        }}
      >
        <Typography.Title
          level={4}
          style={{
            fontWeight: 400,
            margin: "0 0 8px",
            fontFamily: "Inter Variable",
            fontSize: "17px",
          }}
        >
          {t(`brandkit.components.BrandKitAssets.${item}`)}
        </Typography.Title>
        <Flex vertical gap={16}>
          <FontPreviewWrapper>
            <FontPreviewText
              font={currentFont.path}
              style={{
                fontSize: fontPreviewFontSize,
                textAlign: "left",
                padding: 0,
              }}
              text={t("brandkit.components.BrandKitAssets.fontPreviewText")}
            />
          </FontPreviewWrapper>
          <GroupedFontPicker
            value={currentFont.asset_id}
            brandKitFonts={[currentFont]}
            onChange={onFontSelectChange}
            showUploadModal={false}
            useCurrentFontLabel={true}
            style={{
              width: "200px",
            }}
          />
        </Flex>
      </Card>
    </Flex>
  );
};

const FontPreviewWrapper = styled.div`
  padding: 16px;
  border-radius: ${radius.box}px;
  background-color: ${({ theme }) => theme.colorBgContainerDisabled};
`;
